import { UserTablePage } from "~/domain/common";
import { DsmNavigation } from "../../DsmNavigation";

export function DsmUserTablePage() {
  return <UserTablePage navigation={<DsmNavigation />} />;
}
